import { motion } from "framer-motion";
import { Star, Sun, Clock3, HeartHandshake, Flower2 } from "lucide-react";

const QUOTES = [
  {
    icon: Sun,
    text: "Angélique est solaire. À chaque livraison, elle arrive avec le sourire et prend le temps d'un mot gentil. C'est devenu le rendez-vous que j'attends dans la semaine.",
    name: "Monique, 78 ans",
    detail: "Drive hebdomadaire",
  },
  {
    icon: Clock3,
    text: "Toujours disponible, même à la dernière minute. Elle tient ses engagements : quand elle dit une heure, c'est cette heure-là. On ne lâche plus une livreuse pareille.",
    name: "Karim",
    detail: "Colis & courses",
  },
  {
    icon: Flower2,
    text: "Pour l'enterrement de mon père, elle a livré les fleurs avec une délicatesse et une ponctualité remarquables. Dans ces moments-là, quelqu'un de fiable n'a pas de prix.",
    name: "Hélène",
    detail: "Livraison de fleurs",
  },
];

const Stars = () => (
  <span className="flex gap-1" aria-label="Note 5 sur 5">
    {[0, 1, 2, 3, 4].map((i) => (
      <Star key={i} className="h-4 w-4 fill-terra text-terra" />
    ))}
  </span>
);

export default function Testimonials() {
  return (
    <section className="bg-forest py-16 text-cream md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mb-12 max-w-2xl"
        >
          <span className="mb-4 inline-flex w-fit items-center gap-2 rounded-full bg-cream/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-cream/80">
            <HeartHandshake className="h-3.5 w-3.5 text-terra" />
            Ils me font confiance — 5/5 sur toutes mes livraisons
          </span>
          <h2 className="font-serif text-2xl font-semibold tracking-tight sm:text-3xl lg:text-4xl">
            Solaire, disponible, et des promesses <em className="italic text-terra">toujours tenues</em>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">          {QUOTES.map((q, i) => (
            <motion.blockquote
              key={q.name}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="flex flex-col rounded-3xl bg-forest-dark/60 p-6 ring-1 ring-cream/10 sm:p-8"
              data-testid={`testimonial-${i}`}
            >
              <div className="mb-4 flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-cream/10 text-terra">
                  <q.icon className="h-5 w-5" />
                </span>
                <Stars />
              </div>
              <p className="flex-1 font-serif text-lg italic leading-relaxed text-cream/90">{q.text}</p>
              <footer className="mt-6">
                <p className="font-semibold">{q.name}</p>
                <p className="text-sm text-cream/60">{q.detail}</p>
              </footer>
            </motion.blockquote>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-10 text-center text-sm text-cream/60"
          data-testid="track-record-badge"
        >
          Avant Angélivraisons, déjà{" "}
          <strong className="font-semibold text-cream/85">250+ livraisons via Tutut</strong> et{" "}
          <strong className="font-semibold text-cream/85">361 km parcourus via Shopopop</strong> — l'expérience de
          la route, la liberté en plus.
        </motion.p>
      </div>
    </section>
  );
}
